import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#272757',      // BlueEclipse dark blue
      light: '#505081',     // BlueEclipse medium blue for hover states
      dark: '#0f0e47',      // BlueEclipse darkest blue for active states
      contrastText: '#fff', // White text on blue background
    },
    secondary: {
      main: '#8686ac',      // BlueEclipse light blue
      light: '#a5a5c4',     // Lighter variation
      dark: '#505081',      // BlueEclipse medium blue
      contrastText: '#fff',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Optional: removes uppercase text
        },
      },
    },
  },
});

export default theme;
